module.exports = __webpack_public_path__ + "img/makerContent.51688ce7.jpg";